var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 40.625C8.33334 39.2436 8.88208 37.9189 9.85883 36.9421C10.8356 35.9654 12.1603 35.4166 13.5417 35.4166H41.6667",
    stroke: "#C3C3C3",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 4.16663H41.6667V45.8333H13.5417C12.1603 45.8333 10.8356 45.2846 9.85883 44.3078C8.88208 43.3311 8.33334 42.0063 8.33334 40.625V9.37496C8.33334 7.99362 8.88208 6.66886 9.85883 5.69211C10.8356 4.71536 12.1603 4.16663 13.5417 4.16663Z",
    stroke: "#C3C3C3",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIc);
export default __webpack_public_path__ + "static/media/course_ic.b512ace840de3f59e74146bd7da6dc9b.svg";
export { ForwardRef as ReactComponent };